//user constant
export const SET_USER='SET_USER'
export const SET_AUTHENTICATED_USER='SET_AUTHENTICATED_USER'
export const SET_UNAUTHENTICATED='SET_UNAUTHENTICATED'
export const SET_AUTHENTICATED='SET_AUTHENTICATED'
export const LOADING_USER='LOADING_USER'
export const SIGNOUT_ERROR='SIGNOUT_ERROR'
export const GET_SPECIFIC_USER='GET_SPECIFIC_USER'
export const MARK_NOTIFICATIONS_READ='MARK_NOTIFICATIONS_READ'

//data constants
export const GET_POSTS='GET_POSTS'
export const CREATE_POST='CREATE_POST'
export const GET_SPECIFIC_POST='GET_SPECIFIC_POST'
export const CREATE_NEW_COMMENT='CREATE_NEW_COMMENT'
export const LIKE_POST='LIKE_POST'
export const UNLIKE_POST='UNLIKE_POST'
export const DELETE_COMMENT="DELETE_COMMENT"
export const DELETE_POST="DELETE_POST"

//ui constants
export const SET_ERRORS='SET_ERRORS'
export const CLEAR_ERRORS='CLEAR_ERRORS'
export const LOADING_UI='LOADING_UI'
export const LOADING_DATA='LOADING_DATA'
export const SET_PROGRESS_BAR='SET_PROGRESS_BAR'